<template>
  <div>
    <ErrorPage v-if="error404occured" />
    <div v-else class="our-developer">
      <div class="container space-bottom-lg-1 pt-lg-4 pl-0">
        <div aria-label="breadcrumb">
          <ol class="breadcrumb pb-2">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home', params: { lang: $route.params.lang }}">{{ $t('CC01-03-08') }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'our-developers', params: { industry: 'all', lang: $route.params.lang }}">{{ $t('M07b-04') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page"><a class="disabled"> {{ $t(industryName) }}</a></li>
          </ol>
        </div>
      </div>
      <div id="scroll-to-div" class="container">
        <h1 class="mb-5">{{ $t('M07b-04') }}</h1>
        <div class="row">
          <!-- Sticky sidebar -->
          <div id="stickyBlockStartPoint" class="col-xl-3 col-lg-2 pr-xl-5 mb-5 mb-lg-0">
            <!-- Filter -->
            <div>
              <div class="navbar-expand-lg navbar-expand-lg-collapse-block">
                <!-- Responsive Toggle Button -->
                <button v-b-toggle.ourDeveloperSidebarNav class="navbar-toggler btn btn-block border py-3" aria-label="Toggle navigation">
                  <span class="d-flex justify-content-between align-items-center">
                    <span class="h5 mb-0">{{ $t('M07b-03-mobile') }}</span>
                    <span class="navbar-toggler-default">
                      <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z" />
                      </svg>
                    </span>
                    <span class="navbar-toggler-toggled">
                      <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z" />
                      </svg>
                    </span>
                  </span>
                </button>
                <!-- End Responsive Toggle Button -->

                <b-collapse id="ourDeveloperSidebarNav" class="navbar-collapse">
                  <div class="mt-5 mt-lg-0">
                    <h2 class="h4">{{ $t('M07b-03a') }}</h2>
                    <!-- Nav Link -->
                    <div class="tag-container">
                      <a
                        v-for="industryItem in industries.slice(0, 10)"
                        :key="industryItem.value"
                        class="dropdown-item d-flex justify-content-between align-items-center px-0 white-space-normal"
                        :class="{ active: currentIndustry == industryItem.value }"
                        @click="filterCards(industryItem.value)"
                      >
                        {{ $t(industryItem.label) }}
                      </a>
                      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                        <a
                          v-for="industryItem in industries.slice(10)"
                          :key="industryItem.value"
                          class="dropdown-item d-flex justify-content-between align-items-center px-0 white-space-normal"
                          :class="{ active: currentIndustry == industryItem.value }"
                          @click="filterCards(industryItem.value)"
                        >
                          {{ $t(industryItem.label) }}
                        </a>
                      </b-collapse>
                      <div @click="toggleAccordion">
                        <div v-if="industries.length > 10" v-b-toggle="'accordion-1'" class="mt-2 link-collapse font-weight-bold" data-toggle="collapse" aria-expanded="false" aria-controls="accordion-1">
                          <span class="link-collapse-default font-weight-bold">{{ $t('M05b-1-07-01') }}<i class="fas fa-chevron-down ml-2" /></span>
                          <span class="link-collapse-active font-weight-bold">{{ $t('M05b-1-07-02') }}<i class="fas fa-chevron-up ml-2" /></span>
                        </div>
                      </div>
                    </div>
                    <!-- End Nav Link -->
                  </div>
                </b-collapse>
              </div>
            </div>
          <!-- End Filter -->
          </div>
          <!-- End Sticky Sidebar -->

          <!-- Main Partners List Section -->
          <div class="col-xl-9 col-lg-10 mb-5 mb-lg-0 main-container">
            <!-- ===== Partners ===== -->
            <div class="space-bottom-2">
              <!-- <h3 class="mb-5">{{ $t(industryName) }} {{ $t('M07b-05') }}</h3> -->
              <div class="space-bottom-1">
                <form class="input-group input-group-merge" onsubmit="return false;">
                  <input ref="searchKeywordInput" v-model="searchKey" type="search" class="form-control" :placeholder="`${$t('CC06-02-01')} ${$t('M07b-05')}`" :aria-label="`${$t('CC06-02-01')} ${$t('M07b-05')}`" aria-describedby="searchDevelopers" @input="searchDeveloper">
                  <div class="input-group-append">
                    <span id="searchAPI" class="input-group-text">
                      <i class="fas fa-search" />
                    </span>
                  </div>
                </form>
              </div>
              <!-- Card Items -->
              <div class="row mt-3">
                <div v-for="(developer, index) in visibleCard" :key="loaded ? developer.display_name : index" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <DeveloperCard :clickHandler="goToDeveloperInfo" :item="developer" :loading="!loaded" />
                </div>
              </div>
            <!-- End Card Items  -->
            </div>
            <!-- ===== Partners ===== -->
            <div v-if="noOfDevelopers === 0 && searchKey!=='' && loaded" class="result-container">
              <div class="space-1" />
              {{ $t('err-general-01-01', { key: searchKey }) }}
              <div class="space-1" />
            </div>

            <div v-if="noOfDevelopers === 0 && searchKey==='' && loaded" class="text-center">
              <img class="w-lg-40 w-50" src="@/assets/svg/illustrations/construction.svg" alt="Coming Soon SVG">
              <p>{{ $t('CC02b-04c') }}</p>
            </div>

            <!-- === Pagination -->
            <div v-if="noOfDevelopers > 0" aria-label="Page navigation example">
              <Pagination
                :page="currentPage"
                :page-number="Math.ceil(noOfDevelopers/pageSize)"
                :page-change-handler="pageChange"
              />
            </div>
          <!-- === End Pagination -->

          </div>
        </div>
        <!-- End Main Developers List Section -->

        <!-- Sticky Block End Point -->
        <div id="stickyBlockEndPoint" />

        <div class="space-1" />

      </div>
      <!-- ========== Go to Top ========== -->
      <a
        aria-label="go-to-top"
        class="js-go-to go-to position-fixed invisible"
        href="#stickyBlockStartPoint"
        data-hs-go-to-options="{
        &quot;targetSelector&quot; : &quot;#logoAndNav&quot;,
        &quot;offsetTop&quot;: 200,
        &quot;position&quot;: {
          &quot;init&quot;: {
            &quot;right&quot;: 30
          },
          &quot;show&quot;: {
            &quot;bottom&quot;: 30
          },
          &quot;hide&quot;: {
            &quot;bottom&quot;: -30
          }
        }
      }"
      >
        <i class="fas fa-angle-up" />
      </a>
      <!-- ========== End Go to Top ========== -->
    </div>
  </div>
</template>
<script>
const $ = require('jquery')
import DeveloperCard from '@/components/developer-card'
import Pagination from '@/components/pagination'
import HSStickyBlock from '@/assets/vendor/hs-sticky-block/src/js/hs-sticky-block'
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
import ErrorPage from '@/views/error-page/index'
import Axios from 'axios'
import _ from 'lodash'
import { getIndustryList } from '@/api/our-provider'
import { searchDeveloper } from '@/api/our-developer'
import { mapGetters } from 'vuex'
import PartnerCardDummyData from '@/data/partner-card-dummy-data.json'
import { getIndustryCode, getIndustryKeyCodeByValue, getIndustryFormattedName } from '@/utils/format-util'

export default {
  name: 'OurDeveloper',
  components: {
    DeveloperCard,
    ErrorPage,
    Pagination
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 9,
      noOfDevelopers: 0,
      visibleCard: [
        PartnerCardDummyData, PartnerCardDummyData, PartnerCardDummyData,
        PartnerCardDummyData, PartnerCardDummyData, PartnerCardDummyData,
        PartnerCardDummyData, PartnerCardDummyData, PartnerCardDummyData
      ],
      currentIndustry: '',
      items: [],
      cards: [],
      industries: [],
      searchKey: '',
      error404occured: false,
      loaded: false,
      accordionActive: false,
      previousRequest: null,
      handleSearchKeyChange: _.debounce(async function() {
        await this.cancelPreviousRequest()
      }, 200, { 'maxWait': 250 })
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    },
    tableOffset() {
      return (this.currentPage - 1) * this.pageSize
    },
    industryName() {
      if (this.industries !== [] && this.currentIndustry !== '') {
        return this.industries.find(i => i.value === this.currentIndustry) ? this.industries.find(i => i.value === this.currentIndustry).label : ''
      } else return ''
    },
    ...mapGetters(['loading', 'site_info'])
  },
  watch: {
    async userProfile(newProfile) {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      await this.getDeveloperIndustryListInfo()
      if ((newProfile.id !== '') && (newProfile.id !== this.userProfile.id)) {
        if (this.currentIndustry === '') {
          this.currentIndustry = this.$route.params && getIndustryKeyCodeByValue(this.$route.params.industry)
        }
        await this.getDeveloper(this.currentIndustry)
      }
      this.loaded = true
      this.$store.dispatch('app/setLoading', false)
    },
    async $route() {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      this.error404occured = false
      this.currentIndustry = this.$route.params && getIndustryKeyCodeByValue(this.$route.params.industry)
      await this.getDeveloper(this.currentIndustry)
      this.loaded = true
      this.$store.dispatch('app/setLoading', false)
    },
    industryName() {
      this.changeTagName()
    },
    '$i18n.locale'() {
      this.changeTagName()
    }
  },
  mounted() {
    new HSStickyBlock($('.js-sticky-block')).init()
    new HSGoTo($('.js-go-to')).init()
  },
  async created() {
    this.loaded = false
    await this.getDeveloperIndustryListInfo()
    if (this.currentIndustry === '') {
      this.currentIndustry = this.$route.params && getIndustryKeyCodeByValue(this.$route.params.industry)
    }
    await this.getDeveloper(this.currentIndustry ? this.currentIndustry : '')
    this.loaded = true
    this.$store.dispatch('app/setLoading', false)
  },

  methods: {
    goToDeveloperInfo(item) {
      try {
        this.$router.push({
          name: 'developer-info',
          params: {
            lang: this.$route.params.lang,
            developer_name: item.developer_id,
            tab_name: 'overview'
          }
        })
      } catch (err) {
        console.log('err in goToDeveloperInfo', err)
      }
    },
    changeTagName() {
      if (this.industryName !== '' && !this.industryName.includes('ALL')) {
        document.title = `${this.$t(this.industryName)} Developers | ${this.site_info[this.$i18n.locale].name}`
      } else {
        document.title = `Our Developers | ${this.site_info[this.$i18n.locale].name}`
      }
    },
    async cancelPreviousRequest() {
      if (this.previousRequest) {
        this.previousRequest.cancel()
        this.previousRequest = null
      }
      await this.getDeveloperList()
    },
    async pageChange(val) {
      await this.handleCurrentChange(val)
      await this.handleSearchKeyChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$router.push({ name: 'our-developers', params: { industry: getIndustryFormattedName(this.currentIndustry) }})
    },
    async filterCards(val) {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      this.currentIndustry = val
      this.searchKey = ''
      this.handleCurrentChange(1)
      await this.getDeveloper(val)
      this.$store.dispatch('app/setLoading', false)
    },
    async getDeveloperIndustryListInfo() {
      try {
        const { data: industryList } = await getIndustryList()
        var options = industryList
        if (options && options.length > 0) {
          // Sort industry options label in alphabetical order and Move "Others" to the last
          options.sort((a, b) => {
            if (a.content_value === 'Others') return 1
            if (b.content_value === 'Others') return -1
            return a.content_value.toLowerCase() > b.content_value.toLowerCase() ? 1 : b.content_value.toLowerCase() > a.content_value.toLowerCase() ? -1 : 0
          })
        }
        options = options.map(function(industry) {
          return { label: getIndustryCode(industry.content_key), value: industry.content_key }
        })
        this.industries = [{ label: getIndustryCode('ALL'), value: 'ALL' }].concat(options)
      } catch (err) {
        console.log('get Developer Industry List error', err)
        this.industries = [{ label: getIndustryCode('ALL'), value: 'ALL' }]
      }
    },
    async searchDeveloper(e) {
      this.searchKey = e.target.value
      await this.pageChange(1)
    },
    async getDeveloperList() {
      this.loaded = false
      var filter = {}
      if (this.currentIndustry !== 'ALL') {
        filter.industryName = this.currentIndustry
      }
      if (this.searchKey !== '') {
        filter.searchKeyword = this.searchKey
      }
      const axiosSource = Axios.CancelToken.source()
      this.previousRequest = { cancel: axiosSource.cancel }
      await searchDeveloper(axiosSource.token, this.pageSize, this.tableOffset, filter).then(res => {
        const list = res['data'] ? res['data'] : []
        const response = list.map(developer => {
          return {
            ...developer,
            developer_id: developer.id,
            display_name: developer.developer_name,
            profile_picture_url: developer.image_url
          }
        })
        this.visibleCard = response
        this.items = response
        this.noOfDevelopers = parseInt(res.headers['content-range'].split('/')[1])
        this.$refs.searchKeywordInput.focus()
        this.loaded = true
        this.previousRequest = null
      }).catch(err => {
        this.loaded = true
        this.previousRequest = null
        console.log('getDeveloperInfo error', err)
      })
    },
    async getDeveloper(industry_name = '') {
      this.loaded = false
      if ((this.industries.find(i => i.value === industry_name)) || (this.industry_name === '')) {
        industry_name = industry_name === 'ALL' ? '' : this.industries.find(i => i.value === industry_name).label
        await this.getDeveloperList()
        window.scrollTo({ top: $('#scroll-to-div').offset().top - 20, left: 0, behavior: 'smooth' })
        this.loaded = true
      } else {
        this.error404occured = true
        this.loaded = true
        this.$store.dispatch('app/setLoading', false)
      }
    },
    toggleAccordion() {
      this.accordionActive = !this.accordionActive
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.flex-row {
    display: flex;
    flex-direction: row;
}
.tag-container {
  a:hover {
    color: #57abf0;
    cursor: pointer;
  }
  .dropdown-item {
    width: 100%;
    white-space: normal;
  }
  .show-more-button {
    border-radius: 0.5rem;
  }
}
.main-container {
  min-height: 875px;
}
@media (max-width: 992px) {
  .main-container {
    min-height: 0;
  }
}
.disabled {
    pointer-events:none;
    color: #D3D3D3;
}
.modal-header {
    border-bottom: 0;
}
.form-label-group textarea:not(:placeholder-shown) {
    padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
    padding-bottom: calc(var(--input-padding-y) / 3);
}
.form-label-group textarea:not(:placeholder-shown) ~ label {
    padding-top: calc(var(--input-padding-y) / 3);
    padding-bottom: calc(var(--input-padding-y) / 3);
    font-size: 12px;
    color: #777;
}
textarea {
    padding-left: 12px;
}
textarea::placeholder {
    opacity: 0;
}
.result-container {
  display: flex;
  justify-content: center;
  font-size: 20px;
}
.none {
  display: none;
}
.loading-container {
  height: 45vh;
}
.white-space-normal {
  white-space: normal
}
.invisible {
  visibility: hidden;
}
</style>
